$.urlParam = function (name) {

    if (typeof window.__get__ !== 'undefined' && window.__get__[name]) {
        return window.__get__[name]
    }

    let qs     = location.search,
        params = [],
        tokens,
        re     = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        if (decodeURIComponent(tokens[1]) === name) {
            params.push(decodeURIComponent((tokens[2] + '').replace(/\+/g, '%20')));
        }

    }
    if (params.length === 1 && params[0]) {
        return params[0];
    } else if (params.length > 1) {
        return params.filter(
            function (v) {
                if (v) return v;
            }
        );
    } else {
        return null;
    }
};

function phoneFormatter(phone) {
    return phone && phone.replace(/\s/g, '').replace(/(\d{2})(\d{2})(\d{2})(\d{2})(.*)/, '$1 $2 $3 $4$5')
}

$.clicker = ($sel, rep, callback) => {

    $sel.each(function (idx, s) {

        let $s = $(s);
        let f = function (evt) {

            evt.preventDefault();

            let $this = $(this);
            let txt = atob($this.data('n'));

            $this.find(rep).text(txt);
            $this.removeClass('has-tip').attr('title', '');

            let s = $this.data('selector');

            $('span#' + s).remove();

            const source = $this.data('source') || 'Search';


            try {
                ga('send', 'event', `PhoneNumber${source}`, 'Show', $this.data('name'), $this.data('bedrift'));
            } catch (e) {
            }


            let _navigator = {};
            for (let i in navigator) _navigator[i] = navigator[i];

            $.post('/@image/r', {
                nav: JSON.stringify(_navigator),
                b: $this.data('bedrift'),
                p: txt,
                l: location.href
            });

            $this.attr('href', `tel:${txt}`);

            $this.off('click', f);
        };

        const t = phoneFormatter($s.find(rep).text());


        if (!$s.data('n')) {
            $s.data('n', btoa(t));
            $s.find(rep).text(t.substring(0, t.length - 3) + '...')
        }

        $s.attr('href', '#').show();

        $s.on('click', f);
    });
};

$.clicker($('a.phone-hider'), 'strong');

function slugify(text) {
    return text.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');
}

// when the Search Results page loads: transform GET params into AJAX
let GETParams = parseGETParams();

function _initGETResults() {
    if (GETParams != null) {

        for (let p in GETParams) {
            let value = (GETParams[p] + '').replace(/\+/g, ' ');
            $('.is-search-input[name="' + p + '"]').val(value);
        }

        GETParams = {
            q: $.urlParam('q') || '',
            filters: $.urlParam('filters') || '',
            'paths[]': $.urlParam('paths[]') || '',
        };

        $('.fylke_select').trigger('change');

        searchParams.setQuery($.urlParam('q') || '');
        searchParams.setFilter($.urlParam('filters') || '');
        searchParams.setPath($.urlParam('paths[]') || '');
        searchParams.setPage($.urlParam('page') || 1);
        searchParams.setCertification1($.urlParam('certification1') || '');
        searchParams.setCertification2($.urlParam('certification2') || '');
        searchParams.setCertification3($.urlParam('certification3') || '');

        searchParams.doSearch().done(function (response) {
            buildResponse(response);
        });

    }
}

function persistUrl(params) {
    GETParams = GETParams ? GETParams : {};
    //Merging the objects to update the URl
    $.extend(GETParams, params, true);

    if (typeof window.__get__ !== 'undefined') {
        for (let k in window.__get__) {
            delete GETParams[k];
        }
    }


    if (Object.keys(GETParams).length > 0) {
        window.history.pushState(GETParams, window.title, '?' + $.param(GETParams).replace(/\+/g, '%20'));
    }
}

function composeResultImage(image, link) {
    if (!!image) {
        return `<div class="logoBox"><a href="${link}"><img src="${image || ''}" /></a></div>`;
    }

    return '';
}

function formatDistance(dist) {

    dist = dist[dist.length - 1];

    if (dist < 1) {
        return (dist * 1000).toFixed(0) + ' m';
    }
    return dist.toFixed(2) + ' km';
}

function arrayify(val) {
    if (!val) {
        return [];
    }

    return Array.isArray(val) ? val : [val];
}

function strip(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

function composeResultItem(result, isGeo) {
    let category        = result._source.package, // result._source.package,
        servicesWrap    = '',
        serviceListWrap = '';

    let new_item = '';

    let new_item_header =
            `<li class="mix" data-rating="${result._source.rating}"
            data-dist="0" 
            data-alfa="${result._source.name}">
            <div class="listBox category${category} clearfix">
            ${isGeo ? `<span class="distance${result._source.lastUpdated ? ' up' : ''}">${formatDistance(result.sort)}</span>` : ''}
            ${result._source.nationwide === '1' ? `<div class="listBoxBanner bannerNationwide">Landsdekkende</div>` : ''}
            <div class="columns">
            `;


    let new_item_closing_tags = '</div></li>';
    let item_link = '/bedrift/' + result._id + '/' + slugify(result._source.name);


    if (category >= 1) {
        let descr   = strip(result._source.description) || '',
            trimmed = descr.replace(/\n/g, ' ').replace(/^(.{250}[^\s]*).*/, "$1") || '';

        trimmed = trimmed.length < descr.length ? `${trimmed}...<br> <a href="${item_link}">Les mer</a>.` : trimmed;

        if (trimmed === 'null') {
            trimmed = '';
        }


        new_item += `<div class="row">
                        <div class="large-4 medium-4 columns listBrandBox right">
                            ${composeResultImage(result._source.image, item_link)}
                            ${composeResultItemCertLogos(result._source)}
                        </div>
                        <div class="large-8 medium-8 columns listTextBox left">
                            <h3><a href="${item_link}">${result._source.marketing_name || result._source.name}</a></h3>
                            ${trimmed ? `<p>${trimmed}</p>` : ''}
                            ${result._source.marketing_name !== result._source.marketing_name ? '<i>' + result._source.name + '</i>' : ''}
                            ${composeResultItemRating(result._source.rating)}
                        </div>
                    </div>
                    `;
        let phone = phoneFormatter(result._source.phone || '');
        // second row

            new_item += `<div class="row">
                        <div class="large-4 medium-4 columns listContactBox">
                            <p class="bold">
                                ${result._source.alternative_address.replace(/\n/, '<br>')}
                                ${category > 1 ? `<br />
                                <a 
                                    data-n="${btoa(phone)}" 
                                    data-tooltip
                                    data-bedrift="${result._id}"
                                    data-name="${result._source.name}"
                                    title="Vis nummeret"
                                    class="has-tip phone-hider" 
                                    href="tel:${phone}">
                                    <i class="fa fa-phone"/> <strong>${phone.substring(0, phone.length - 3) + '...'}</strong>
                                </a>` : ``}
                            </p>
                        </div>`;

        servicesWrap = $('<div id="services-company-' + result._source.doc + '" class="large-8 medium-8 columns listServicesBox companyServicesList"/>');
        serviceListWrap = $('<ul class=""/>');

        $.get('/@documents/services', {
            params: {
                bedrift: result._id,
                enabled: 1
            }
        }).done(function (response) {

            if (response.documents.length) {
                $.each(response.documents, function (i, e) {
                    serviceListWrap.append(composeResultServiceItem(e));
                });

                $('#services-company-' + result._source.doc)
                    .append('<strong>Våre tjenester</strong>')
                    .append(serviceListWrap);
            }
        });

        new_item += servicesWrap[0].outerHTML;

        let gallery_wrap  = $('<div id="company-' + result._source.doc + '"></div>'),
            resultGallery = '';

        $.get('/@documents/gallery', {
            params: {
                bedrift: result._id,
            }
        }).done(function (response) {
            if (response.documents.length) {
                resultGallery = composeResultItemGallery(response.documents);
                let column_wrap = $('<div class="columns listGalleryBox"> <h5> Bildegalleri: </h5> </div>');
                column_wrap.append(resultGallery);

                $('#company-' + result._source.doc).append(column_wrap);
            }
        });


        new_item += gallery_wrap[0].outerHTML;


        return $(new_item_header + new_item + new_item_closing_tags);

    }

    if (category === 32) {
        // first row
        new_item += '<div class="row"><div class="large-8 medium-8 columns listTextBox"><h3><a href="' + item_link + '">' + (result._source.marketing_name ? result._source.marketing_name : result._source.name) + '</a></h3>';

        new_item += result._source.marketing_name ? '<i>' + result._source.name + '</i>' : '';

        new_item += composeResultItemRating(result._source.rating);

        new_item += '<p>' + (result._source.description || '') + '</p></div><div class="large-4 medium-4 columns listBrandBox"><div class="logoBox"><a href="' + item_link + '"><img src="' + (result._source.image || '') + '" /></a></div>';

        new_item += composeResultItemCertLogos(result._source);

        new_item += '</div></div>';

        // second row
        new_item += '<div class="row"><div class="large-4 medium-4 columns listContactBox"><p class="bold">' + result._source.address1 + '<br /> ' + result._source.address2 + '<br />Tlf: ' + result._source.phone + '</p></div>';

        servicesWrap = $('<div id="services-company-' + result._source.doc + '" class="large-8 medium-8 columns listServicesBox companyServicesList"><strong>Våre tjenester</strong></div>');
        serviceListWrap = $('<ul class="large-block-grid-3 medium-block-grid-3 small-block-grid-2"></ul>');

        let docs = 0;

        $.get('/@documents/services', {
            params: {
                bedrift: result._id,
            }
        }).done(function (response) {

            docs = response.documents.length;

            if (response.documents.length) {

                $.each(response.documents, function (i, e) {
                    serviceListWrap.append(composeResultServiceItem(e));
                });

                $('#services-company-' + result._source.doc).append(serviceListWrap);
            }
        });

        new_item += servicesWrap[0].outerHTML;

        return $(new_item_header + new_item + new_item_closing_tags);
    }

    if (category === 22) {
        new_item += '<div class="row"><div class="large-8 medium-8 columns listTextBox"><h4><a href="' + item_link + '">' + (result._source.marketing_name ? result._source.marketing_name : result._source.name) + '</a></h4>';

        new_item += result._source.marketing_name ? '<i>' + result._source.name + '</i>' : '';

        new_item += composeResultItemRating(result._source.rating);

        new_item += '<p>' + (result._source.description || '') + '</p>';

        new_item += '</div><div class="large-4 medium-4 columns listBrandBox">';

        new_item += composeResultItemCertLogos(result._source);

        new_item += '</div><div class="large-12 columns listContactBox">';

        new_item += '<p class="bold">' + result._source.alternative_address + ', Tlf: ' + result._source.phone + '</p></div></div></div>';

        return $(new_item_header + new_item + new_item_closing_tags);

    }
    // We didn't use an 'else' clause because those 3 Package-related fields are checkboxes on the
    // DNA panel, therefore we need to prevent errors here
    if ((category !== 2 && category !== 3) || category === 12) {
        new_item += '<div class="row"><div class="large-8 medium-8 columns listTextBox"><h5><a href="' + item_link + '"> ' + (result._source.marketing_name ? result._source.marketing_name : result._source.name) + '</a></h5>';

        new_item += result._source.marketing_name ? '<i>' + result._source.name + '</i>' : '';

        new_item += '<p>' + result._source.address1 + ', ' + result._source.address2 + '</p>';

        new_item += composeResultItemRating(result._source.rating);

        new_item += '</div><div class="large-4 medium-4 columns listBrandBox">';

        new_item += composeResultItemCertLogos(result._source);

        new_item += '</div></div>';

        return $(new_item_header + new_item + new_item_closing_tags);
    }

}

function composeResultItemRating(rating) {
    let html = '<div class="companyRating">';
    for (let i = 0; i < 5; i++) {
        html += `<i class="fa fa-thumbs-${(i < rating ? 'up' : 'o-up')} aria-hidden="true"></i>`;
    }

    return html + '</div>';
}

function composeResultItemCertLogos(obj) {
    let html = '<div class="certificationLogos"><ul>';

    let item_link = '/bedrift/' + obj.doc + '/' + slugify(obj.name);

    if (obj.certification1) {
        html += `<li>
            <div class="logoBox">
                <a href="${item_link}">
                    <img src="/media/dist/images/logoer/mesterlogo.png" alt="Mesterbedrift"/>
                </a>
            </div>
        </li>`;
    }
    if (obj.certification2) {
        html += `<li><div class="logoBox">
            <a href="${item_link}">
                <img src="/media/dist/images/logoer/${obj.pbl === "PBL 2016" ? "dibk_new_approved.png" : "ansvarsrett_farge-333.png"}" alt="Godkjent for ansvarsrett  ${obj.pbl}."/>
            </a>
        </div>
    </li>`;
    }
    if (obj.certification3) {
        html += `<li><div class="logoBox">
            <a href="${item_link}">
                <img src="/media/dist/images/logoer/GodkjentVaatromsbedrift.jpg" 
                alt="Godkjent Våtromsbedrift"/>
            </a>
        </div>
    </li>`;
    }

    html += '</ul></div>';

    return html;
}

function composeResultServiceItem(item) {

    let html = `<li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a href="#" class="moreToggle"><span>${item.name}</span></a>
                    <!-- <div class="serviceInfoBox">
                        <div class="serviceInfoBoxInner">
                            <div class="servieceInfoBoxTxt">
                                <h5>${item.name}</h5>
                                <p>${item.fields.description.value}</p>
                            </div>
                            <div class="serviceInfoBoxArrow"></div>
                        </div>
                    </div> -->
                </li>`;

    return $(html);
}

function initChocolat($choc) {

    $choc.Chocolat({
        imageSize: 'contain',
        afterMarkup: function (a, b, c) {
            let instance = $choc.data('chocolat');
            $choc.find('a.chocolat-image').each((idx, img) => {
                instance.settings.images[idx].src = `${$(img).attr('href')}`;
            });
        }
    });
}


function composeResultItemGallery(gallery) {
    let ul = $('<ul/>').addClass('thumbBoxes');

    const lis = gallery.reduce((acc, element) => `${acc}<li>
                    <div class="thumbBox">
                        <a class="chocolat-image" 
                            href="${element.fields.picture.value}" 
                            title="${element.fields.tekst.value}"
                            data-caption="${element.fields.tekst.value}">
                            <img src="${element.fields.picture.value}/-/resize/130x/" alt="${element.fields.bedrift.value}">
                        </a>
                    </div>
                </li>
        `, '');

    ul.append(lis);

    initChocolat(ul);

    return ul;
}

const should_check = (data, key) => data.map(i => i.indexOf(key) === 0).reduce((i, c) => c || i, false);

function updateFilters(data, ajax_filters) {
    // 'Sertifiseringer' filters (fixed)
    let c2,
        $faq_filter_list = $('.fag_filter_list');
    for (let i = 0; i < data.aggregations.dibk.buckets.length; i++) {
        if (data.aggregations.dibk.buckets[i].key_as_string === 'true') {
            c2 = data.aggregations.dibk.buckets[i].doc_count;
        }
    }
    if (c2 > 0) {
        $('.certification_filter_list li').eq(0).html('<label><input type="checkbox" name="certification2" ' + (ajax_filters.certification2 ? 'checked="checked"' : '') + ' /> Sentral godkjenning (' + c2 + ')</label>');
    } else {
        $('.certification_filter_list li').eq(0).html('');
    }
    let c3;
    for (let i = 0; i < data.aggregations.fvv.buckets.length; i++) {
        if (data.aggregations.fvv.buckets[i].key_as_string === 'true') {
            c3 = data.aggregations.fvv.buckets[i].doc_count;
        }
    }
    if (c3 > 0) {
        $('.certification_filter_list li').eq(1).html('<label><input type="checkbox" name="certification3" ' + (ajax_filters.certification3 ? 'checked="checked"' : '') + ' /> Godkjent våtromsbedrift (' + c3 + ')</label>');
    } else {
        $('.certification_filter_list li').eq(1).html('');
    }

    // 'Bransjer' filters
    $faq_filter_list.html('');
    let fag_response = data.aggregations.agg_subjects.buckets, html = '';
    for (let i = 0; i < fag_response.length; i++) {
        let item = fag_response[i];
        if (item.doc_count > 0) {
            html += '<li><label><input type="checkbox" value="' +
                item.key + '" name="filters[]" ' +
                ((ajax_filters['filters[]'].indexOf(item.key) !== -1) ? 'checked="checked"' : '') + ' /> ' +
                item.key + ' (' + item.doc_count + ')</label>';
        }
    }

    $faq_filter_list.html(html);

    // 'Områder' filters
    $('.omrader_filter_list').html('');

    let omrader_response = data.__, path = '';

    searchParams.setPath(ajax_filters['paths[]']);

    for (let key in omrader_response) {

        let omrader = omrader_response[key];

        path = key;

        let attr = should_check(searchParams.getPath(), path) ? 'checked="checked"' : '';
        let isChecked = (attr === '') ? '' : 'class="checked"';

        let $filter_item = $(`<li ${isChecked}>
                <label><input class="area_filter_list" type="checkbox" data-path="${key}" value="${key}" name="filters[]" ${attr} /> ${key} (${omrader.count})</label>`);

        let $sublist = $('<ul class="kommune_filter_list"></ul>');

        let places = omrader.children;

        for (let place_key in places) {
            let sub_item = places[place_key];

            path = key + '/' + place_key;

            let attr             = should_check(searchParams.getPath(), path) ? 'checked="checked"' : '',
                isChecked        = (attr === '') ? '' : 'class="checked"',
                $filter_sub_item = $(`<li ${isChecked}><label><input type="checkbox" data-path="${path}" value="${place_key}" name="filters[]" ${attr} /> ${place_key} (${sub_item.count})</label>`);

            $sublist.append($filter_sub_item);


            /* cityparts */
            let $subsublist = $('<ul class="bydel"></ul>');
            let cityparts = sub_item.children;
            for (let city_key in cityparts) {
                let sub_sub_item = cityparts[city_key];

                path = key + '/' + place_key + '/' + city_key;

                let attr      = should_check(searchParams.getPath(), path) ? 'checked ="checked"' : '',
                    isChecked = (attr === '') ? '' : 'class="checked"';
                $subsublist.append($(`<li ${isChecked}><label><input type="checkbox" data-path="${path}" value="${city_key}" name="filters[]" ${attr} /> ${city_key} (${sub_sub_item.count})</label>`))

            }

            $filter_sub_item.append($subsublist);

        }

        $filter_item.append($sublist);


        $('.omrader_filter_list').append($filter_item);
    }
}

function parseGETParams() {
    'use strict';

    if (!location.search || location.search.indexOf('=') < 0) {
        return null;
    }

    let params = {};
    location.search.substr(1).split('&').forEach(function (p) {
        let pair = p.split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
    });

    if (typeof window.__get__ !== 'undefined') {
        for (let k in window.__get__) {
            params[k] = window.__get__[k];
        }
    }

    return params;
}

